import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";
import { AlertList } from "@/components/ui/alert";
import { vbsContactUrl } from "@/lib/vbs";
import { useVbsSyncWarnings } from "./useVbsSyncWarnings";

/**
 * `warning` rather than `info`: the fix is in VBS, and until it is made these people cannot be
 * planned. It clears itself, because the sync rebuilds the table from each run.
 */
export function VbsSyncWaarschuwing() {
  const { t } = useTranslation(["paginas"]);
  const { data: warnings } = useVbsSyncWarnings();

  if (!warnings?.length) return null;

  return (
    <AlertList
      tone="warning"
      className="mb-6"
      title={t("paginas:ondersteuners.vbsWaarschuwing.titel", { count: warnings.length })}
      description={t("paginas:ondersteuners.vbsWaarschuwing.uitleg")}
    >
      <ul className="space-y-1">
        {warnings.map((warning) => (
          <li key={warning.vbsContactId}>
            {warning.reason === "MissingEmail"
              ? t("paginas:ondersteuners.vbsWaarschuwing.ontbrekendEmail", {
                  naam: warning.name,
                  soort: warning.soort,
                })
              : t("paginas:ondersteuners.vbsWaarschuwing.dubbelEmail", {
                  naam: warning.name,
                  soort: warning.soort,
                  email: warning.email,
                })}{" "}
            (
            <a
              href={vbsContactUrl(warning.vbsContactId)}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-0.5 text-muted-foreground underline-offset-4 hover:underline"
            >
              {t("paginas:ondersteuners.vbsWaarschuwing.vbsNummer", {
                nummer: warning.vbsContactId,
              })}
              <ExternalLink aria-hidden className="size-3" />
            </a>
            )
          </li>
        ))}
      </ul>
    </AlertList>
  );
}
